// extracted by mini-css-extract-plugin
export default {"container":"scroll-number_container__d0YH8"};